import { useSessionTutorial } from '@/features/session-tutorial/SessionTutorialProvider';
import type { TutorialAnchorProps } from '@/features/session-tutorial/sessionTutorial.types';
import { Slot } from '@radix-ui/react-slot';
import { useCallback } from 'react';

/** Marks its child as what the tutorial's `step` points at (spotlight and tip are placed against it). */
export const TutorialAnchor = ({
  step,
  advanceOnClick = false,
  unavailable = false,
  children,
}: TutorialAnchorProps) => {
  const tutorial = useSessionTutorial();
  const register = tutorial?.register;
  const ref = useCallback(
    (element: HTMLElement | null) => (element && register ? register(step, element) : undefined),
    [register, step]
  );
  if (!tutorial || unavailable) return children;

  return (
    <Slot
      ref={ref}
      // Lit-only anchors (`listening`, `generating`) are not steps: there is nothing to complete.
      onClick={
        advanceOnClick && step !== 'generating' && step !== 'listening' ? () => tutorial.complete(step) : undefined
      }
    >
      {children}
    </Slot>
  );
};
